import React, { Component } from 'react'; 

class NotFoundPage extends Component {
  render(){
    return(
      <div>
        <p>
          Oops! Page does not exist.
        </p>
      </div>
    ) 
  }
}

export default NotFoundPage; 